"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8030],{

/***/ 51313:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DemystLogoWhite.51bb8a67.svg","height":40,"width":162});

/***/ }),

/***/ 69519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ StandardFormComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/landingPage/views/components/Button.jsx
var Button = __webpack_require__(88749);
// EXTERNAL MODULE: ./src/landingPage/views/components/form/TermsCheckbox.jsx
var TermsCheckbox = __webpack_require__(17609);
// EXTERNAL MODULE: ./src/landingPage/views/Forms/templates/components/StandardField.jsx + 7 modules
var StandardField = __webpack_require__(24606);
// EXTERNAL MODULE: ./src/landingPage/utils/form-functions.js
var form_functions = __webpack_require__(67534);
// EXTERNAL MODULE: ./src/landingPage/datasets/formComponent.js
var formComponent = __webpack_require__(86713);
// EXTERNAL MODULE: ./src/config/userTracking.js
var userTracking = __webpack_require__(67474);
// EXTERNAL MODULE: ./src/api/userApi.js
var userApi = __webpack_require__(62725);
// EXTERNAL MODULE: ./src/api/api.js
var api = __webpack_require__(84557);
;// CONCATENATED MODULE: ./src/api/publicApi.js



var publicApi = {
    sendRegistrant: function sendRegistrant(webinarId, registrant) {
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return api/* demystConsoleApi.post */.Es.post("/public/webinars/".concat(webinarId, "/registrants"), {
                            registrant: registrant
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }
};

// EXTERNAL MODULE: ./src/utils/formAttribution.js
var formAttribution = __webpack_require__(64357);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/landingPage/views/components/FormComponent.jsx















var StandardFormComponent = function(param) {
    var data = param.data, changeModalOpen = param.changeModalOpen, changeErrorModalOpen = param.changeErrorModalOpen, pipedriveType = param.pipedriveType, formName = param.formName, gaName = param.gaName, caseStudy = param.caseStudy, _resetValuesAfterwards = param.resetValuesAfterwards, resetValuesAfterwards = _resetValuesAfterwards === void 0 ? false : _resetValuesAfterwards, _isConsent = param.isConsent, isConsent = _isConsent === void 0 ? true : _isConsent, customButtonText = param.customButtonText, _isButtonInverted = param.isButtonInverted, isButtonInverted = _isButtonInverted === void 0 ? false : _isButtonInverted, setFlagPresent = param.setFlagPresent, webinarIdZoom = param.webinarIdZoom, setModalOpen = param.setModalOpen;
    var ref = (0,react.useState)({}), formData = ref[0], changeFormData = ref[1];
    var ref1 = (0,react.useState)({}), errors = ref1[0], changeErrors = ref1[1];
    var ref2 = (0,react.useState)(false), consent = ref2[0], changeConsent = ref2[1];
    var ref3 = (0,react.useState)(false), sending = ref3[0], changeSending = ref3[1];
    var router = (0,next_router.useRouter)();
    var pathname = router.asPath;
    var ref4 = (0,react.useState)(null), linkedInCookie = ref4[0], setLinkedInCookie = ref4[1];
    (0,react.useEffect)(function() {
        setLinkedInCookie(localStorage.getItem("li_fat_id"));
    }, []);
    var isFirstLastNamePresent = function(fields) {
        var isFirstName = typeof fields.first_name !== "undefined";
        var isLastName = typeof fields.last_name !== "undefined";
        if (!isFirstName && !isLastName) return false;
        return true;
    };
    var resetForm = function() {
        var newFormData = {};
        data.fields.forEach(function(field) {
            if (field.component !== "standard-multielement") {
                newFormData[field.id] = "";
            } else {
                field.fields.forEach(function(subfield) {
                    newFormData[subfield.id] = "";
                });
            }
        });
        if (isFirstLastNamePresent(newFormData) === true) newFormData.full_name = "".concat(newFormData.first_name, " ").concat(newFormData.last_name);
        changeFormData(newFormData);
        changeConsent(false);
    };
    var changeData = function(e, data) {
        var newFormData = (0,_object_spread/* default */.Z)({}, formData);
        newFormData[data.id] = e;
        if (data.id === "first_name" || data.id === "last_name") {
            newFormData.full_name = "".concat(newFormData.first_name, " ").concat(newFormData.last_name);
        }
        changeFormData(newFormData);
    };
    var preparedData = function() {
        var preparedData = (0,formAttribution/* formAttribution */.e)(pipedriveType);
        if (formName !== "Catalog Bottom") {
            preparedData = (0,_object_spread/* default */.Z)({}, preparedData, formData);
        } else {
            preparedData.full_name = formData.full_name_bottom;
            preparedData.email = formData.email_bottom;
        }
        return preparedData;
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var dataToSend, setUserTracking, registrantPayload, webinarId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!(!sending && (0,form_functions/* validate */.G)({
                            formData: formData,
                            data: data,
                            changeErrors: changeErrors,
                            consent: isConsent ? consent : true
                        }) === true)) {
                            _ctx.next = 27;
                            break;
                        }
                        changeSending(true);
                        dataToSend = {
                            type: formName,
                            formValues: preparedData()
                        };
                        linkedInCookie && (0,userTracking.sendLinkedInConversion)();
                        setUserTracking = function() {
                            var formattedUserToTrack = {
                                user: {
                                    email: formData.email,
                                    name: formData.full_name
                                }
                            };
                            if (formData.company_name || formData.company_name === "") formattedUserToTrack.organization = {
                                name: formData.company_name || ""
                            };
                            if (formName === "Catalog Bottom") {
                                formattedUserToTrack.user = {
                                    email: formData.email_bottom,
                                    name: formData.full_name_bottom
                                };
                            }
                            var gaEmail = formName === "Catalog Bottom" ? formData.email_bottom : formData.email;
                            var urlPath = pathname;
                            if (formName === "Solutions whitepaper") urlPath = "/solution/whitepaper";
                            if (formName === "Webinar video") urlPath = "/webinar_video";
                            (0,userTracking/* sendGaEvent */.k8)({
                                action: "Form Submission",
                                category: "Lead",
                                label: "Submit - ".concat(gaName ? gaName : formName, " Form - ").concat(urlPath)
                            }, gaEmail);
                        };
                        _ctx.prev = 6;
                        if (!(formName === "Webinar registration")) {
                            _ctx.next = 12;
                            break;
                        }
                        registrantPayload = {
                            email: formData.email,
                            full_name: formData.full_name,
                            company_name: formData.company_name || "",
                            job_title: formData.job_title || "",
                            message: formData.message || ""
                        };
                        webinarId = webinarIdZoom.replaceAll(" ", "");
                        _ctx.next = 12;
                        return publicApi.sendRegistrant(webinarId, registrantPayload);
                    case 12:
                        dataToSend.formValues.case_study = caseStudy;
                        _ctx.next = 15;
                        return userApi/* userApi.sendFrontForm */.B.sendFrontForm(dataToSend);
                    case 15:
                        if (formName === "Webinar video") {
                            setFlagPresent && setFlagPresent(true);
                            localStorage.setItem("video_form_filled", true);
                        }
                        setUserTracking();
                        resetValuesAfterwards && resetForm();
                        changeModalOpen && changeModalOpen(true);
                        setModalOpen && setModalOpen(true);
                        changeSending(false);
                        _ctx.next = 27;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t0 = _ctx["catch"](6);
                        changeErrorModalOpen && changeErrorModalOpen(true);
                        changeSending(false);
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    6,
                    23
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        resetForm();
    }, []);
    return Object.keys(formData).length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: handleSubmit,
            noValidate: true,
            title: formName,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardField/* StandardField */.y, {
                    fields: data.fields,
                    formData: formData,
                    changeData: changeData,
                    errors: errors
                }),
                isConsent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            id: "consent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsCheckbox/* TermsCheckbox */.H, {
                            text: formComponent/* formComponent.form.consent */.j.form.consent,
                            checked: consent,
                            onChange: changeConsent,
                            error: errors.consent
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        disabled: sending,
                        variant: isButtonInverted ? "inverted" : "primary",
                        demystIcon: true,
                        children: customButtonText || formComponent/* formComponent.button_text */.j.button_text
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 84135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65966);







var LinkButton = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, isExternal = _param.isExternal, onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, to = _param.to, children = _param.children, className = _param.className, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "isExternal",
        "onClick",
        "variant",
        "size",
        "disabled",
        "to",
        "children",
        "className",
        "noStyle"
    ]);
    var classes = noStyle !== true ? (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button-component", variant === "inverted" && "button-component-inverted", variant === "secondary" && "button-component-secondary", variant === "secondary-alt" && "button-component-secondary-alt", hidden && "hidden", autoWidth && "button-component-autoWidth", size && "button-component-size-".concat(size), disabled && "button-component-disabled", className) : className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        href: to,
        className: classes,
        onClick: function(e) {
            onClick && onClick(e);
        },
        isExternal: isExternal
    }, props), {
        children: [
            noStyle !== true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            }) : children,
            demystIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};


/***/ }),

/***/ 40782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ InfoBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Attention.svg
/* harmony default export */ var Attention = ({"src":"/_next/static/media/Attention.623c0e2a.svg","height":18,"width":20});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Error.svg
/* harmony default export */ var Error = ({"src":"/_next/static/media/Error.ff5ef9c7.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Success.svg
/* harmony default export */ var Success = ({"src":"/_next/static/media/Success.47ce7b03.svg","height":20,"width":20});
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/landingPage/views/components/form/InfoBox.jsx









var getIcon = function(type) {
    switch(type){
        case "Attention":
            return Attention.src;
        case "Success":
            return Success.src;
        default:
            return Error.src;
    }
};
var getMessage = function(type) {
    switch(type){
        case "Attention":
            return "The page you tried to access does not exist. If you think this is a mistake, please contact Demyst support.";
        case "Success":
            return "Your form has been sent successfully. We'll be in touch.";
        default:
            return "There was an unexpected internal error with our server. Please contact Demyst support.";
    }
};
var getActionText = function(type) {
    switch(type){
        case "Success":
            return "Return Home";
        default:
            return "Contact Support";
    }
};
var getActionLink = function(type) {
    switch(type){
        case "Success":
            return linksConstants/* linksConstants.HOME */.s.HOME;
        default:
            return linksConstants/* linksConstants.CONTACT */.s.CONTACT;
    }
};
var InfoBox = function(param) {
    var actionLink = param.actionLink, actionText = param.actionText, _actionVisible = param.actionVisible, actionVisible = _actionVisible === void 0 ? true : _actionVisible, closeModal = param.closeModal, _fromContact = param.fromContact, fromContact = _fromContact === void 0 ? false : _fromContact, text = param.text, title = param.title, _type = param.type, type = _type === void 0 ? "Success" : _type;
    var ref = (0,react.useState)(false), componentMounted = ref[0], setComponentMounted = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            return setComponentMounted(true);
        }, 200);
    }, []);
    var closeWithFade = function() {
        setComponentMounted(false);
        setTimeout(function() {
            closeModal();
        }, 500);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "info_box-main ".concat(componentMounted ? "" : "initiated"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "info_box-icon_box ".concat(type.toLowerCase()),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "info_box-icon",
                    src: getIcon(type),
                    alt: type
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "info_box-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "info_box-header",
                        children: title || "".concat(type, "!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "info_box-message",
                        children: text || getMessage(type)
                    }),
                    actionVisible && !fromContact && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        onClick: closeModal,
                        className: "info_box-action",
                        href: actionLink || getActionLink(type),
                        children: actionText || getActionText(type)
                    }),
                    actionVisible && fromContact && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: closeModal,
                        className: "info_box-action",
                        href: actionLink || getActionLink(type),
                        children: actionText || getActionText(type)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "info_box-close",
                onClick: function() {
                    return closeWithFade();
                },
                title: "Close",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiX */.q5L, {})
            })
        ]
    });
};
InfoBox.propTypes = {
    actionLink: (prop_types_default()).string,
    actionText: (prop_types_default()).string,
    actionVisible: (prop_types_default()).bool,
    closeModal: (prop_types_default()).func,
    fromContact: (prop_types_default()).bool,
    text: (prop_types_default()).string,
    title: (prop_types_default()).string,
    type: (prop_types_default()).string
};


/***/ }),

/***/ 17609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ TermsCheckbox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var TermsCheckbox = function(param) {
    var checked = param.checked, onChange = param.onChange, text = param.text, error = param.error, _classNameForText = param.classNameForText, classNameForText = _classNameForText === void 0 ? "terms_checkbox-text" : _classNameForText, _classNameMain = param.classNameMain, classNameMain = _classNameMain === void 0 ? "terms_checkbox-main" : _classNameMain, _classNameContainer = param.classNameContainer, classNameContainer = _classNameContainer === void 0 ? "terms_checkbox-container" : _classNameContainer, _classNameError = param.classNameError, classNameError = _classNameError === void 0 ? "terms_checkbox-error" : _classNameError;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: classNameMain,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "terms_checkbox-label",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classNameContainer,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "checkbox",
                                value: text,
                                checked: checked,
                                onChange: function() {
                                    return onChange(!checked);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "terms_checkbox-box"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: classNameForText,
                        children: [
                            text.beginning,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    className: "demyst-blue",
                                    href: text.link1_url,
                                    children: text.link1_text
                                })
                            }),
                            text.separator,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    className: "demyst-blue",
                                    href: text.link2_url,
                                    children: text.link2_text
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: classNameError,
                children: error
            })
        ]
    });
};


/***/ }),

/***/ 11024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6805);
/* harmony import */ var _config_appConfig__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84762);









var Modal = function(param) {
    var open = param.open, onBackdropClick = param.onBackdropClick, backdropClassName = param.backdropClassName, motionElementClassName = param.motionElementClassName, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), renderPortalWrapper = ref[0], setRenderPortalWrapper = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), renderContent = ref1[0], setRenderContent = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (open) {
            setRenderPortalWrapper(true);
            setRenderContent(true);
        } else {
            setRenderContent(false);
            setTimeout(function() {
                return setRenderPortalWrapper(false);
            }, 200);
        }
    }, [
        open
    ]);
    if (!renderPortalWrapper) return null;
    // TODO: Create focus trap
    return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "Modal",
        role: "presentation",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .AnimatePresence */ .M_, {
            children: renderContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .motion.div */ .ww.div, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("Modal__motionElement", motionElementClassName)
            }, _config_appConfig__WEBPACK_IMPORTED_MODULE_4__/* .animatePresenceConfig */ .Rr), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("Modal__backdrop", backdropClassName),
                        onClick: onBackdropClick,
                        "aria-hidden": "true"
                    }),
                    children
                ]
            }), "modal")
        })
    }), document.querySelector("#__next"));
};
Modal.propTypes = {
    backdropClassName: prop_types__WEBPACK_IMPORTED_MODULE_8__.PropTypes.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_8__.PropTypes.node,
    motionElementClassName: prop_types__WEBPACK_IMPORTED_MODULE_8__.PropTypes.string,
    onBackdropClick: prop_types__WEBPACK_IMPORTED_MODULE_8__.PropTypes.func,
    open: prop_types__WEBPACK_IMPORTED_MODULE_8__.PropTypes.bool
};


/***/ }),

/***/ 64357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ formAttribution; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);

var formAttribution = function(body) {
    var landingPage = localStorage.getItem("landing_page");
    var landingPageDatetime = localStorage.getItem("landing_page_datetime");
    var landingPageFullUrl = localStorage.getItem("landing_page_full_url");
    var currentPagePath = localStorage.getItem("current_page_path");
    var currentPagePathDatetime = localStorage.getItem("current_page_path_datetime");
    var prevPagePath = localStorage.getItem("prev_page_path");
    var prevPagePathDatetime = localStorage.getItem("prev_page_path_datetime");
    var pageFlow = JSON.parse(localStorage.getItem("page_flow"));
    var sessionPageFlow = JSON.parse(sessionStorage.getItem("session_page_flow"));
    var gaAdCookie = localStorage.getItem("gaAd");
    var gaAdCookieUpdated = localStorage.getItem("gaAd_updated");
    var gaAdCookieCreated = localStorage.getItem("gaAd_created");
    var isProductKickingAss = (landingPage === null || landingPage === void 0 ? void 0 : landingPage.startsWith("/external-data/")) || (landingPage === null || landingPage === void 0 ? void 0 : landingPage.startsWith("/third-party-data/"));
    var googleAdsGclid = localStorage.getItem("gclid");
    var googleAdsGclidCreated = localStorage.getItem("gclid_created");
    var googleAdsGclidUpdated = localStorage.getItem("gclid_updated");
    var linkedInCookie = localStorage.getItem("li_fat_id");
    var linkedInCookieCreated = localStorage.getItem("li_fat_id_created");
    var linkedInCookieUpdated = localStorage.getItem("li_fat_id_updated");
    var utmMedium = localStorage.getItem("utm_medium");
    var utmMediumCreated = localStorage.getItem("utm_medium_created");
    var utmMediumUpdated = localStorage.getItem("utm_medium_updated");
    var utmSource = localStorage.getItem("utm_source");
    var utmSourceCreated = localStorage.getItem("utm_source_created");
    var utmSourceUpdated = localStorage.getItem("utm_source_updated");
    var utmCampaign = localStorage.getItem("utm_campaign");
    var utmCampaignCreated = localStorage.getItem("utm_campaign_created");
    var utmCampaignUpdated = localStorage.getItem("utm_campaign_updated");
    var utmContent = localStorage.getItem("utm_content");
    var utmContentCreated = localStorage.getItem("utm_content_created");
    var utmContentUpdated = localStorage.getItem("utm_content_updated");
    var utmTerm = localStorage.getItem("utm_term");
    var utmTermCreated = localStorage.getItem("utm_term_created");
    var utmTermUpdated = localStorage.getItem("utm_term_updated");
    var marketingSource = linkedInCookie ? "linkedin" : googleAdsGclid ? "google(cpc)" : null;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        body: body
    }, landingPage && {
        landing_page: landingPage
    }, landingPageFullUrl && {
        landing_page_full_url: landingPageFullUrl
    }, landingPageDatetime && {
        landing_page_datetime: landingPageDatetime
    }, currentPagePath && {
        current_page_path: currentPagePath
    }, currentPagePathDatetime && {
        current_page_path_datetime: currentPagePathDatetime
    }, prevPagePath && {
        prev_page_path: prevPagePath
    }, prevPagePathDatetime && {
        prev_page_path_datetime: prevPagePathDatetime
    }, sessionPageFlow && {
        session_page_flow: sessionPageFlow
    }, pageFlow && {
        macro_page_flow: pageFlow
    }, utmMedium && {
        utm_medium: utmMedium
    }, utmMediumCreated && {
        utm_medium_created: utmMediumCreated
    }, utmMediumUpdated && {
        utm_medium_updated: utmMediumUpdated
    }, utmSource && {
        utm_source: utmSource
    }, utmSourceCreated && {
        utm_source_created: utmSourceCreated
    }, utmSourceUpdated && {
        utm_source_updated: utmSourceUpdated
    }, utmCampaign && {
        utm_campaign: utmCampaign
    }, utmCampaignCreated && {
        utm_campaign_created: utmCampaignCreated
    }, utmCampaignUpdated && {
        utm_campaign_updated: utmCampaignUpdated
    }, utmContent && {
        utm_content: utmContent
    }, utmContentCreated && {
        utm_content_created: utmContentCreated
    }, utmContentUpdated && {
        utm_content_updated: utmContentUpdated
    }, utmTerm && {
        utm_term: utmTerm
    }, utmTermCreated && {
        utm_term_created: utmTermCreated
    }, utmTermUpdated && {
        utm_term_updated: utmTermUpdated
    }, marketingSource && {
        marketing_source: marketingSource
    }, gaAdCookie && {
        gaAd: gaAdCookie
    }, gaAdCookieCreated && {
        gaAd_created: gaAdCookieCreated
    }, gaAdCookieUpdated && {
        gaAd_updated: gaAdCookieUpdated
    }, isProductKickingAss && {
        pikYa: isProductKickingAss
    }, googleAdsGclid && {
        gclid: googleAdsGclid
    }, googleAdsGclidCreated && {
        gclid_created: googleAdsGclidCreated
    }, googleAdsGclidUpdated && {
        gclid_updated: googleAdsGclidUpdated
    }, linkedInCookie && {
        li_fat_id: linkedInCookie
    }, linkedInCookieCreated && {
        li_fat_id_created: linkedInCookieCreated
    }, linkedInCookieUpdated && {
        li_fat_id_updated: linkedInCookieUpdated
    }, document.referrer && {
        referrer: document.referrer
    });
};


/***/ })

}]);